import React from 'react';
import _ from 'lodash';

interface Props {
  text: string | null | undefined;
}
const Text = ({ text }: Props) => {
  return (
    <div>
      {text &&
        typeof text === 'string' &&
        text.split('\n').map((line, i) => <p key={i}>{_.isEmpty(line) ? <br /> : line}</p>)}
    </div>
  );
};

export default Text;
